import React, { Component } from 'react';
import Checkbox from 'Components/Checkbox';
import {RIL, ROQUETTE } from 'Constants/commonConstants';
import { getUser } from 'Utils/storage';

class BiddingDetails extends Component {
    constructor(props) {
        super(props);
        this.rfqDetails = props.rfqDetails;
        this.viewMode = props.viewMode;
        this.state = {
            allowBidding : props.rfqDetails.allowBidding,
            acceptPartialSolution: props.rfqDetails.acceptPartialSolution,
            biddingType: props.rfqDetails.biddingType
        };
    }
    setAllowBidding = (allowBidding)=> {
        if(this.viewMode) {
            return;
        }
        this.setState({
            allowBidding
        });
        this.rfqDetails.setAllowBidding(allowBidding);
    } 
    setAcceptPartialSolution = (acceptPartialSolution)=> {
        if(this.viewMode) {
            return;
        }
        this.setState({
            acceptPartialSolution
        });
        this.rfqDetails.setAcceptPartialSolution(acceptPartialSolution);
    } 
    setBiddingType = (type) => {
        if(this.viewMode) {
            return;
        }
        this.setState({
            biddingType: type
        });
        this.rfqDetails.setBiddingType(type);
    }
    shouldRenderBiddingType = () => {
        const C1 = ROQUETTE.includes(getUser().companyId);
        const C2 = RIL.includes(getUser().companyId);  
        if(C1) {
            return true;
        }
        if(C2) {
            return true;
        }
        return false;
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            acceptPartialSolution:nextProps.rfqDetails.acceptPartialSolution,
        })
     }
     
    render() {
        return (
            <div className="box-shadow ph-20 pv-20 br-5">
                <div className="fBold fs-22 border-bottom-light lh-40p mb-30">
                    Bidding Details
                </div>
                {/* <div className="fBold fs-18 mb-10 header-medium-color">
                    Allow bidding
                </div>
                <div className="flex mb-40">
                    <Checkbox label="Yes" checked={this.state.allowBidding} className="mr-30" onCheck={this.setAllowBidding.bind(this, true)}/>
                    <Checkbox label="No" checked={!this.state.allowBidding} onCheck={this.setAllowBidding.bind(this, false)}/>
                </div> */}

                <div className="fBold fs-18 mb-10 header-medium-color">
                    Bidding Solution
                </div>
                <div className="flex">
                    <Checkbox label="Partial Solution" checked={this.state.acceptPartialSolution} className="mr-30" onCheck={this.setAcceptPartialSolution.bind(this, true)}/>
                    <Checkbox label="Complete Solution" checked={!this.state.acceptPartialSolution} onCheck={this.setAcceptPartialSolution.bind(this, false)}/>
                </div>

                {this.shouldRenderBiddingType() && 
                <>
                    <div className="fBold fs-18 mb-10 header-medium-color mt-40">
                        Bidding Type
                    </div>
                    <div className="flex">
                        <Checkbox label="Post Bid" checked={this.state.biddingType === 1} className="mr-30" onCheck={() => this.setBiddingType(1)} disabled={this.viewMode} />
                        <Checkbox label="Pre Bid" checked={this.state.biddingType === 2} onCheck={() => this.setBiddingType(2)} disabled={this.viewMode}/>
                    </div>
                </>}
                
            </div>
        )
    }
}

export default BiddingDetails;
